<template>
  <b-navbar class="mb-3" toggleable="xl" type="dark" variant="primary" sticky>
    <b-navbar-brand>Deutsche Meisterschaften 2020</b-navbar-brand>
    <b-navbar-toggle target="sidebar" class="mr-4"></b-navbar-toggle>
    <b-collapse is-nav>
      <NavBarLinks/>
      <b-navbar-nav class="ml-auto">
        <b-nav-item :to="{ name: 'Login' }">Log out</b-nav-item>
      </b-navbar-nav>
    </b-collapse>

    <b-sidebar id="sidebar" bg-variant="light" text-variant="primary"
               title="Deutsche Meisterschaften 2020" shadow>
      <nav>
        <b-navbar-nav class="bg-primary text-center" vertical>
          <NavBarLinks/>
          <b-nav-item :to="{ name: 'Login' }">Log out</b-nav-item>
        </b-navbar-nav>
      </nav>
    </b-sidebar>
  </b-navbar>
</template>

<script>
import NavBarLinks from './NavBarLinks.vue';

export default {
  name: 'NavigationBar',
  components: { NavBarLinks },
  methods: {
    logout() {
      console.log('Logged out');
      // this.$http.get('session/logout')
      //   .then(() => {
      //     this.$session.destroy();
      //     this.$router.push({ name: 'login' });
      //   }).catch((error) => {
      //     console.error(error);
      //     alert('unexpected error');
      //   });
    },
  },
};
</script>
